import SharedHelper from '@/Helpers/Shared';
export default {
  mixins: [SharedHelper],
  data() {
    return {
      isMissionSettedAs10_60: true,
    };
  },
  methods: {
    setCancleReaonFor115MissionFunction: function (uniqueId_NewCall = "") {
      if (!this.editMissionTenNineteenNote) {
        this.snackText = 'توضیحات نمی تواند خالی باشد.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        state: '10-19',
        note: this.editMissionTenNineteenNote,
        missionPhoneId: this.missionPhoneId ? this.missionPhoneId : null,
        missionId: this.missionId,
      };
      this.$store.dispatch('setMissionStateDispatch', data).then(() => {
        if (this.$store.state.missionStateModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.editMissionSelectedCancleReason = null;
          this.editMissionTenNineteenNote = '';
          this.tenNineteenModal = false;
          if (this.type == 'fromMainList') {
            this.$root.$refs.Mission115View.edit115MissionModal = false;
            this.getListOfCurrentMissionFunction();
          } else if (this.type == 'fromNewCall') {
            this.$root.$refs[`newCallComponent_${uniqueId_NewCall}`].currentMissionModal = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionStateModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setCancleReaonFor115MissionFunction(uniqueId_NewCall ?? "");
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionStateModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setCancleReaonFor115MissionFunction(uniqueId_NewCall ?? "");
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setMissionStateAs10_60: function (missionId = this.missionId, missionPhoneId = null, onSuccess, state) {
      const body = {
        state,
        missionId,
        missionPhoneId,
      };
      this.$store
        .dispatch('setMissionStateDispatch', body)
        .then(() => {
          if (this.$store.state.missionStateModule.successFlag) {
            onSuccess();
            this.setMissionSettedAs10_60(true);
          } else {
            if (this.$store.state.missionStateModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.setMissionStateAs10_60((missionId = this.missionId), (missionPhoneId = null), onSuccess, state);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionStateModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.setMissionStateAs10_60((missionId = this.missionId), (missionPhoneId = null), onSuccess, state);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getAllMissionStateFunction: function (missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllMissionStateFor115Mission', {
          missionId: missionId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.missionStateModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            let temp = this.$store.state.missionStateModule.allMissionState;
            if (this.tab == 'two') {
              //جزئیات ماموریت 115
              this.readyStateData(temp);
            }
            if (this.editTab == 'time') {
              //جزئیات ماموریت 800
              this.readyStateData(temp);
            }
            if (this.$route.name == 'dashboardFollowUp') {
              //جزئیات ماموریت پیگیری
              this.readyStateData(temp);
            }
            if (this.$route.name == 'missionReport') {
              //گزارش پرونده
              this.readyStateData(temp);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionStateModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllMissionStateFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionStateModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllMissionStateFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    showError: function () {
      this.snackText = this.$store.state.missionStateModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
    setMissionSettedAs10_60: function (value) {
      this.isMissionSettedAs10_60 = value;
    },
  },
  watch: {
    missionId: function (missionIdValue) {
      if (missionIdValue) this.setMissionSettedAs10_60(false);
    },
  },
};
